import React from "react";
import { Container, Col, Row } from "react-bootstrap";
import {
  FaTwitter,
  FaInstagram,
  FaYoutube,
  FaDiscord,
  FaTiktok,
} from "react-icons/fa";
import logo from "./../assets/logomark.svg";
import { NavLink } from "react-router-dom";
import { Image as CloudImage } from "cloudinary-react";
import NewsLetter from "./NewsLetter";

import { HashLink } from "react-router-hash-link";

export default function Footer() {
  return (
    <>
      <footer className="pb-2 showcase">
        <Container>
          <Row className=" pt-5">
            <Col md={4} className="  mb-3">
              <div className="d-flex ">
                <div className="d-flex flex-column align-items-center ">
                  <CloudImage
                    cloudName="zerko"
                    publicId="zerko_type_mmkfid"
                    width="150"
                    crop="scale"
                    alt="zerko"
                  />
                  <span className="d-flex mt-3 flex-wrap justify-content-center">
                    <a
                      className="d-flex nav-link my-auto social_link"
                      target="_blank"
                      rel="noreferrer"
                      href="https://www.twitter.com/zerkogg"
                    >
                      <FaTwitter size={22} className="" />
                    </a>

                    <a
                      className="d-flex nav-link  my-auto social_link"
                      target="_blank"
                      rel="noreferrer"
                      href="https://www.instagram.com/zerkogg"
                    >
                      <FaInstagram size={22} className="" />
                    </a>
                    <a
                      className="d-flex nav-link  my-auto social_link"
                      target="_blank"
                      rel="noreferrer"
                      href="https://www.youtube.com/zerkogg"
                    >
                      <FaYoutube size={24} className="" />
                    </a>
                    <a
                      className="d-flex nav-link  my-auto social_link"
                      target="_blank"
                      rel="noreferrer"
                      href="https://discord.gg/ekscSGmg27"
                    >
                      <FaDiscord size={24} className="" />
                    </a>
                    <a
                      className="d-flex nav-link  my-auto social_link"
                      target="_blank"
                      rel="noreferrer"
                      href="https://www.tiktok.com/@zerkogg?"
                    >
                      <FaTiktok size={20} className="" />
                    </a>
                  </span>
                </div>
              </div>
            </Col>
            <Col md={4} className=" mb-3     ">
              <div className="d-flex ">
                <div className="d-flex flex-column align-items-start ">
                  <h6 className="text-accent fw-normal">EXPLORE</h6>
                  <HashLink to="/#description" className=" nav-link px-1">
                    {" "}
                    <span className="social_link fw-bolder">About Us</span>
                  </HashLink>

                  <NavLink to="/team" className=" nav-link px-1">
                    {" "}
                    <span className="social_link fw-bolder">Our Team</span>
                  </NavLink>
                  <HashLink to="/#contact" className=" nav-link px-1">
                    {" "}
                    <span className="social_link fw-bolder">Contact Us</span>
                  </HashLink>
                </div>
              </div>
            </Col>
            <Col md={4} className=" mb-3 d-flex flex-column ">
              <h6 className="text-accent fw-normal">ZERKO NEWSLETTER</h6>
              <p className="text-accent">
                Subscribe to get the latest news, updates, and recruitment
                opportunities for Zerko!
              </p>

              {/*Mailchimp Newsletter Subscription*/}
              <NewsLetter />
            </Col>
          </Row>
          <div className=" pt-3 mt-3   d-flex flex-column justify-content-center align-items-center ">
            <img src={logo} width="48" className="mb-2" alt="logo" />
            <span className="d-flex-inline my-auto ">
              <h6 className="text-accent">
                Zerko, Inc &copy; {new Date().getFullYear()} All rights reserved
              </h6>
            </span>
          </div>
        </Container>
      </footer>
    </>
  );
}
